@let filesArr = files();
<div
  class="input-wrapper"
  [ngClass]="{
    'has-addon': hasAddon(),
    'has-attachment': filesArr && filesArr.length > 0,
    rounded: rounded(),
    large: large(),
  }">
  @if (filesArr && filesArr.length > 0) {
    <div class="attachments-wrapper">
      @for (file of filesArr; track $index) {
        @let fileKind = file.file.type | fileKind;
        <div class="attachment" [ngClass]="'attachment-type-' + fileKind">
          @switch (fileKind) {
            @case ('IMAGE') {
              @if (file.src) {
                <orbit-fa-icon
                  class="delete-image-icon"
                  [iconName]="closeIcon"
                  (click)="deleteAttachment($index)" />
                <img [src]="file.src" alt="" />
              }
            }
            @case ('VIDEO') {
              <orbit-fa-icon class="video-file-icon" [iconName]="videoFileIcon" />
              <orbit-fa-icon
                class="delete-video-icon"
                [iconName]="closeIcon"
                (click)="deleteAttachment($index)" />
            }
            @case ('AUDIO') {
              <audio controls [src]="file.src"></audio>
              <orbit-fa-icon
                class="delete-audio-icon"
                [iconName]="closeIcon"
                (click)="deleteAttachment($index)" />
            }
          }
        </div>
      }
    </div>
  }

  @let rightAddon = addonRight();
  @let leftAddon = addonLeft();
  <div
    class="form-field-wrapper"
    [ngClass]="{
      'has-addon': hasAddon(),
      'addon-left': leftAddon?.button || leftAddon?.icon,
      'addon-right': rightAddon?.button || rightAddon?.icon,
    }">
    @if (leftAddon) {
      <div class="addon left-addon" [style]="{ 'align-self': leftAddon.vAlign ?? 'center' }">
        @if (leftAddon.button) {
          <orbit-button
            [rounded]="rounded()"
            [disabled]="disabled() || loading()"
            [icon]="leftAddon?.icon"
            [label]="leftAddon?.label"
            [testId]="'btn-input-addon-left'"
            (onClick)="emitAddonButtonClicked()" />
        } @else if (leftAddon.icon) {
          <orbit-fa-icon
            class="simple-icon"
            [iconName]="leftAddon.icon"
            (click)="emitAddonIconClicked()" />
        } @else if (leftAddon.label) {
          <span class="addon-label">{{ leftAddon.label }}</span>
        }
      </div>
    }

    @if (inputType() === 'textarea') {
      <textarea
        #textarea
        [attr.id]="inputId()"
        [attr.placeholder]="placeholder()"
        [attr.data-testid]="testId()"
        [name]="name()"
        (keydown)="typing($event)"
        (keydown.enter)="emitEnterPressed($event, true)"
        [formControl]="controller()"
        autosize
        [minRows]="textareaAutosizeLimit().minRows"
        [maxRows]="textareaAutosizeLimit().maxRows"></textarea>
    } @else {
      <input
        #input
        [autocomplete]="autocomplete() ? 'on' : 'off'"
        [type]="inputType()"
        [attr.id]="inputId()"
        [attr.placeholder]="placeholder()"
        [attr.data-testid]="testId()"
        [name]="name()"
        (keydown)="typing($event)"
        (keydown.enter)="emitEnterPressed($event)"
        [formControl]="controller()" />
    }

    @if (rightAddon) {
      <div class="addon right-addon" [style]="{ 'align-self': rightAddon.vAlign ?? 'center' }">
        @if (rightAddon.button) {
          <orbit-button
            [rounded]="rounded()"
            [disabled]="rightAddon?.disabled ?? false"
            [icon]="rightAddon?.icon"
            [label]="rightAddon?.label"
            [testId]="'btn-input-addon-right'"
            (onClick)="emitAddonButtonClicked()" />
        } @else if (rightAddon.icon) {
          <orbit-fa-icon
            class="simple-icon"
            [iconName]="rightAddon.icon"
            (click)="emitAddonIconClicked()" />
        } @else if (rightAddon.label) {
          <span class="addon-label">{{ rightAddon.label }}</span>
        }
      </div>
    }
  </div>
</div>
